"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOrdinal = void 0;
const pr = new Intl.PluralRules("en-US", { type: "ordinal" });
const suffixes = new Map([
    ["one", "st"],
    ["two", "nd"],
    ["few", "rd"],
    ["other", "th"],
]);
const toOrdinal = (n) => {
    const rule = pr.select(n);
    const suffix = suffixes.get(rule);
    return `${n}${suffix}`;
};
exports.toOrdinal = toOrdinal;
//# sourceMappingURL=to-ordinal.js.map